<template>
  <span>
    <reason 
      compressed
      :row-type="itemType"
      :reason = "makePersonMatch"
      :clickable="false"
      hideTip
    > 
    </reason>

    <v-card-text>
      <div>
      <big-story
        :item-reason="itemReason"
        :story-header="storyHeader"
        :row-type="itemType"
        missingInformation="searching"
      ></big-story>
      </div>
    </v-card-text>

    <div v-if="contentReasons">
      <div flat xs12 v-for="(contentReason, index) in contentReasons" :key="index">
        <content-detail
          :items="getItems(contentReason)"
          :all-prizes="allPrizes"
          :compressed="compressed"
          :row-type="getRowType (contentReason)"
          :item-type="itemType"
          :hideable="false"
          hide-icon-column
          :toolbar-color="toolbarColor"
          :cardColor="color"
          hide-toolbar
        ></content-detail>
      </div>
    </div>
    <div v-else>
      <v-progress-circular
        indeterminate
        color="amber"
      ></v-progress-circular>
    </div>
  </span>
</template>
    
<script>

import { SearchUtils } from '@/js'
import { getIconColor } from '@/js/store'
import { PersonPage } from '@/gql'
import Bigstory from '@/components/Bigstory'
import Contentdetail from '@/components/Contentdetail'
import Reason from '@/components/Reason'
export default {
  props: {
    item: Object,
    makePersonMatch: Object
  },
  components: {
    'big-story': Bigstory,
    'content-detail': Contentdetail,
    'reason': Reason
  },
  data: () => ({
    PersonPage: null
  }),
  methods: {
    getItems (contentReason) {
      return contentReason.reasons
    },
    getRowType (contentReason) {
      return contentReason.rowType
    }
  },
  computed: {
    allPrizes() {
      // TODO make this better
      return null
    },
    compressed () {
      return true
    },
    contentReasons () {
      if (!this.searcherItem) return []
      return this.rowTypes.map(rowType => {
        // filter out the items for this type
        const reasons = SearchUtils.filterReasons(this.searcherItem, rowType)
        // if its coompressed, then all the reasons come on a single row so delegate that
        // but in the tip its always compressed
        return {
          reasons,
          rowType
        }
      })
    },
    rowTypes () {
      return ['film','company']
    },
    storyHeader() {
      return ''
    },
    toolbarColor () {
      return this.color + ' lighten-2'
    },
    color () {
      return getIconColor(this.itemType)
    },
    itemReason () {
      return this.searcherItem && this.searcherItem.itemReason
    },
    searcherItem () {
      return SearchUtils.makeSearcherFromPerson(this.PersonPage)
    },
    person () {
      console.log(this.searcherItem)
      return this.searcherItem
    },
    itemName () {
      return this.item && this.item.itemName
    },
    itemID () {
      return this.item && this.item.itemID
    },
    itemType () {
      return this.item && this.item.itemType
    }
  },
  apollo: {
    PersonPage: {
      query: PersonPage,
      skip () {
        return this.itemType !== 'person' || !this.itemID 
      },
      variables () {
        return {
          id: this.itemID
        }
      }
    }
  }
}
</script>
